// extracted by mini-css-extract-plugin
export default {"container":"document-item_container__emTDG","progress":"document-item_progress__4SYK-","tramite_pendiente":"document-item_tramite_pendiente__K480F"};